import {
  Card,
  CardHeader,
  CardContent,
  Stack,
} from "@mui/material";
import FlightIcon from "@mui/icons-material/Flight";
import StatBar from 'components/StatBar';

const TopFlightsCard = ({ data = [], onFlightClick }) => {
  if (!data.length) return null;

  return (
    <Card 
      sx={{ 
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 1, 
        border: `1px solid`,
        borderColor: "neutral.deep",
      }}
    >
      <CardHeader
        title="Top Flights by Logs"
        subheader=""
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 2,
          backgroundColor: "background.paper",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      />
      <CardContent sx={{ overflowY: "auto", flex: 1 }}>
        <Stack spacing={1}>
          {data?.map((f) => (
            <StatBar
              key={f.key}
              icon={<FlightIcon fontSize="small" color="success" />}
              label={f.label}
              count={f.count}
              percent={f.percent}
              color="success.main"
              onClick={() => onFlightClick(f)}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default TopFlightsCard;
